// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"680":"90d8891a","840":"38624db2","949":"905a794d"}[chunkId] + ".chunk.js";
};